// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader__root--_Yq6 {
    --loader-size: 24px;

    width: var(--loader-size);
    height: var(--loader-size);
    animation: Loader__loader--T80g 1.2s steps(8) infinite;
}

    .Loader__root--_Yq6.Loader__secondary--V8IS {
        --loader-size: 40px;
    }

    .Loader__root--_Yq6.Loader__secondary--V8IS path:nth-child(1) {
            stroke: #3857FFE0;
        }

    .Loader__root--_Yq6.Loader__secondary--V8IS path:nth-child(2) {
            stroke: #3857FFC0;
        }

    .Loader__root--_Yq6.Loader__secondary--V8IS path:nth-child(3) {
            stroke: #3857FFA0;
        }

    .Loader__root--_Yq6.Loader__secondary--V8IS path:nth-child(4) {
            stroke: #3857FF80;
        }

    .Loader__root--_Yq6.Loader__secondary--V8IS path:nth-child(5) {
            stroke: #3857FF60;
        }

    .Loader__root--_Yq6.Loader__secondary--V8IS path:nth-child(6) {
            stroke: #3857FF40;
        }

    .Loader__root--_Yq6.Loader__secondary--V8IS path:nth-child(7) {
            stroke: #3857FF20;
        }

    .Loader__root--_Yq6.Loader__secondary--V8IS path:nth-child(8) {
            stroke: #3857FF00;
        }

@keyframes Loader__loader--T80g {
    to {
        transform: rotate(1turn);
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Loader/Loader.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;;IAEnB,yBAAyB;IACzB,0BAA0B;IAC1B,sDAAwC;AAqC5C;;IAnCI;QACI,mBAAmB;IAiCvB;;IA/BI;YACI,iBAAiB;QACrB;;IAEA;YACI,iBAAiB;QACrB;;IAEA;YACI,iBAAiB;QACrB;;IAEA;YACI,iBAAiB;QACrB;;IAEA;YACI,iBAAiB;QACrB;;IAEA;YACI,iBAAiB;QACrB;;IAEA;YACI,iBAAiB;QACrB;;IAEA;YACI,iBAAiB;QACrB;;AAIR;IACI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".root {\n    --loader-size: 24px;\n\n    width: var(--loader-size);\n    height: var(--loader-size);\n    animation: loader 1.2s steps(8) infinite;\n\n    &.secondary {\n        --loader-size: 40px;\n\n        path:nth-child(1) {\n            stroke: #3857FFE0;\n        }\n\n        path:nth-child(2) {\n            stroke: #3857FFC0;\n        }\n\n        path:nth-child(3) {\n            stroke: #3857FFA0;\n        }\n\n        path:nth-child(4) {\n            stroke: #3857FF80;\n        }\n\n        path:nth-child(5) {\n            stroke: #3857FF60;\n        }\n\n        path:nth-child(6) {\n            stroke: #3857FF40;\n        }\n\n        path:nth-child(7) {\n            stroke: #3857FF20;\n        }\n\n        path:nth-child(8) {\n            stroke: #3857FF00;\n        }\n    }\n}\n\n@keyframes loader {\n    to {\n        transform: rotate(1turn);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Loader__root--_Yq6`,
	"loader": `Loader__loader--T80g`,
	"secondary": `Loader__secondary--V8IS`
};
export default ___CSS_LOADER_EXPORT___;
